import { useEffect, useState } from 'react';
import { differenceInSeconds, parse } from 'date-fns';

export const useCountDown = ({ endDate }) => {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(endDate));

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft(endDate);
      setTimeLeft(newTimeLeft);

      if (newTimeLeft.total <= 0) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  return { timeLeft };
};

const calculateTimeLeft = (endDate) => {
  if (!endDate) return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };

  const end = parse(endDate, 'yyyy-MM-dd HH:mm:ss', new Date());
  const now = new Date();
  const total = differenceInSeconds(end, now);

  const days = Math.floor(total / (3600 * 24));
  const hours = Math.floor((total % (3600 * 24)) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  return {
    total,
    days,
    hours,
    minutes,
    seconds,
  };
};
